t = require('views/internal/teacup-with-helpers')('enterprise_detail')

module.exports = t.renderable (data) ->
  { displayName, enforcesSso } = data

  t.div '.tabbed-pane-header', ->
    t.div '.tabbed-pane-header-wrapper.u-clearfix', ->

      t.a class: t.classify('tabbed-pane-header-image': true, 'profile-image': true), href: '#', ->
        t.span '.profile-image-icon.icon-lg.icon-enterprise'

      t.div '.tabbed-pane-header-details', ->
        t.div '.tabbed-pane-header-details-name', ->
          t.h1 '.u-inline', ->
            t.text displayName

          t.span '.window-title-extra', ->
            t.icon 'enterprise'
            t.format 'enterprise'

          t.span '.window-title-extra', ->
            if enforcesSso
              t.icon 'private'
              t.format 'sso-enforced'
            else
              t.icon 'public'
              t.format 'not-sso-enforced'

        t.div '.tabbed-pane-header-details-content', { dir: 'auto' }, ->
          t.format 'enterprise-admin'

    # This is here as the safest way to get a consistent bottom border,
    # with the assumption that at some point we'll replace this with a <ul>
    # and tabs
    t.div '.tabbed-pane-nav'

  t.div '.tabbed-pane-main-col.u-clearfix', ->
    t.div '.tabbed-pane-main-col-loading.hide.js-loading-page', ->
      t.span '.tabbed-pane-main-col-loading-spinner.spinner'
    t.div class: t.classify('tabbed-pane-main-col-wrapper': true, 'js-content': true, 'is-full-width': true)



// WEBPACK FOOTER //
// ./app/scripts/views/templates/enterprise_detail.coffee